import axios from './axios';

export default {
  get: async query => {
    const { data } = await axios.get('/around-me/aroundme', {
      params: query
    });
    return data;
  },

  getMinResponse: async query => {
    const { data } = await axios.get('/around-me/aroundme-minimized', {
      params: query
    });
    return data;
  },

  getNew: async query => {
    const { data } = await axios.get('/around-me/aroundme-new', {
      params: query
    });
    return data;
  },

  kindValues: async query => {
    const params = { params: query };
    const { data } = await axios.get(
      `/around-me/documents-kind/values`,
      params
    );
    return data;
  },

  documentsProjectValues: async query => {
    const params = { params: query };
    const { data } = await axios.get(
      `/around-me/documents-project/values`,
      params
    );
    return data;
  },

  profilesProjectValues: async query => {
    const params = { params: query };
    const { data } = await axios.get(
      `/around-me/profiles-project/values`,
      params
    );
    return data;
  }
};
